import '../../publicPath';
import loadPolyfills from '../2-polyfill';

import bootstrapApp from './bootstrap';

(async () => {
  await loadPolyfills();
  await bootstrapApp();
})();
